import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Avatar from '@material-ui/core/Avatar';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import TenantProfile from 'aurora-images/tenant_profile.svg';
import CompanyIcon from 'aurora-images/Company.svg';
import Paper from '@material-ui/core/Paper';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { isArray } from 'lodash';
import styles from './styles';
function ContractParties(props) {
  const { classes, contractors = [], title } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const locale = localStorage.getItem('lang');

  const renderContractorItem = (item, index) => (
    <div className={classes.contractorContainer}>
      {(index === 0 || index === 1) && (
        <Typography className={classes.contractorTitle} variant='h6' component='h5'>
          {keyEmptyCheck(index === 0 ? 'first_party' : 'second_party')}
        </Typography>
      )}
      <div className={classes.contractorContent}>
        <Avatar
          alt={locale === 'en' ? item?.nameEn : item?.nameAr}
          src={item?.isCompany ? CompanyIcon : TenantProfile}
          className={classes.contractorImg}
        />
        <Typography className={classes.contractorHeading} variant='h6' component='h3'>
          {locale === 'en' ? item?.nameEn : item?.nameAr}
        </Typography>
      </div>
    </div>
  );

  return (
    <Paper variant='outlined' className={classes.paperCardFrame}>
      <div className={classes.titleHead}>
        <Typography variant='h6' component='h2' className={classes.Title}>
          {keyEmptyCheck(title)}
        </Typography>
      </div>
      <div className={classes.contractorsListContainer}>
        {isArray(contractors)
          ? (isCollapsed ? contractors.slice(0, 2) : contractors).map((contract, i) =>
              renderContractorItem(contract, i),
            )
          : null}
      </div>
      {isArray(contractors) && contractors.length > 2 ? (
        <div className={classes.viewBtnContainer}>
          {isCollapsed ? (
            <Link className={classes.viewBtn} onClick={() => setIsCollapsed(false)}>
              {keyEmptyCheck('view_more')}
              <ExpandMoreIcon />
            </Link>
          ) : (
            <Link className={classes.viewBtn} onClick={() => setIsCollapsed(true)}>
              {keyEmptyCheck('view_less_reasons')}
              <ExpandLessIcon />
            </Link>
          )}
        </div>
      ) : null}
    </Paper>
  );
}

ContractParties.propTypes = {
  classes: PropTypes.object.isRequired,
  contractors: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(ContractParties);
